import React from 'react';

import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

import { noop } from 'ui-components/default-props/noop';

import BillToAccountExtraInput from './bill-to-account-extra-input';
import { BILL_OPTIONS } from './constants/bill-to-account-options';
import { InputLabel } from '../../../../../address/input-label/index';
import { emptyArray } from 'ui-components/default-props/empty';

import style from '../inputs.module.less';

export const messages = defineMessages({
  accountNumber: {
    description: 'otherShippingOptions.billTo.accountNumber',
    defaultMessage: 'Account #',
    id: 'p5k7y9',
  },
  billingCountry: {
    description: 'otherShippingOptions.country',
    defaultMessage: 'Country',
    id: '0lGnGu',
  },
  billingPostalCode: {
    description: 'otherShippingOptions.billTo.postalCode',
    defaultMessage: 'Postal Code',
    id: 't0HWQ8',
  },
});

const BillToAccountExtra = ({ isBulkUpdate = false, options = emptyArray, updateInputValue = noop, updateBillToAccount = noop }) => (
  <>
    {Object.entries(options).map(([key, value]) => {
      const fieldId = key === BILL_OPTIONS.billingCountry ? key : `${key}-input`;

      return (
        <div key={key} className={style['bill-to-row']}>
          <InputLabel labelFor={fieldId} required={isBulkUpdate}>
            <FormattedMessage {...messages[key]} />
          </InputLabel>
          <BillToAccountExtraInput
            id={fieldId}
            option={key}
            updateBillToAccount={updateBillToAccount}
            updateInputValue={updateInputValue}
            value={value}
          />
        </div>
      );
    })}
  </>
);

BillToAccountExtra.propTypes = {
  isBulkUpdate: PropTypes.bool,
  options: PropTypes.shape({
    accountNumber: PropTypes.string,
    billingCountry: PropTypes.string,
    billingPostalCode: PropTypes.string,
  }),
  updateInputValue: PropTypes.func,
  updateBillToAccount: PropTypes.func,
};

export default BillToAccountExtra;
